/**
 * Classe utilitaire pour la configuration de la carte.
 */
export class MapConfigUtil {
	private static readonly URL_MAP_QUERY_SUFFIX = '&STYLE=normal&FORMAT=image/png&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}';

	static resolveMapUrl(urlMap: string, service: string, request: string, version: string, layer: string): string {
		const query = `?SERVICE=${service}&REQUEST=${request}&VERSION=${version}&LAYER=${layer}${MapConfigUtil.URL_MAP_QUERY_SUFFIX}`;

		return urlMap.includes('?') ? urlMap : `${urlMap}${query}`;
	}

	static resolveAttribution(attributionMap: string): string {
		return `Données cartographiques: ${attributionMap}`;
	}
}